import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IItemSourceSentenceTranslationValidatorCreate, IItemSourceSentenceTranslationValidatorEdit, IItemSourceSentenceTranslationValidatorListItem } from 'types/itemSourceSentenceTranslationValidator';
import { IKline } from '../types/klines';

export type ItemSourceSentenceTranslationValidatorModelOptions = IModelOptions & {
  courseId: number;
};

export class ItemSourceSentenceTranslationValidatorModel extends BaseModel<
  IItemSourceSentenceTranslationValidatorListItem,
  IItemSourceSentenceTranslationValidatorEdit
> {
  constructor(options: ItemSourceSentenceTranslationValidatorModelOptions) {
    super(options);
    this.ref = IRefIds.itemSourceSentenceTranslationValidator;
    this.gridName = 'ItemSourceSentenceTranslationValidator';
    this.courseId = options.courseId;
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IItemSourceSentenceTranslationValidatorListItem[]>(`/courses/${this.courseId}/item-source-sentence-translation-validator`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IKline>(`/courses/${this.courseId}/item-source-sentence-translation-validator/${itemId}`);
  }

  async createJob(data: IItemSourceSentenceTranslationValidatorCreate) {
    const response = await post<{ id: number; message: string }>(`/courses/${this.courseId}/item-source-sentence-translation-validator`, data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`item-source-sentence-translation-validator/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IItemSourceSentenceTranslationValidatorEdit>(`item-source-sentence-translation-validator/${itemId}`);
  }

  async changePriority(itemId: number, priority: number) {
    await put(`/item-source-sentence-translation-validator/${itemId}/change-priority`, { priority });
  }
}